import React, { Component } from 'react';
import ReportHeader from '../../ReportHeader'
import ReportHeader2 from '../../ReportHeader2'
import Section from '../../ReportSection/index'
import ErrorTable from '../ErrorTableEnterprise'
import T from 'i18n-react'
import cn from 'classnames'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import SuccessStatus from '../../SuccessStatus/index'
import SubtestSummary from '../../SubtestSummary/index'
import { compose } from 'recompose';
import {
  Table,
  TableHead,
  TableRow,
  TableCell
} from 'react-toolbox'
import CollapsableOverlay from 'components/custom/CollapsableOverlay'


class NvlinkQualTestEnterprise extends Component {

  constructor(props) {
    super(props)
    this.state = {
      curRun: 0,
      curDevice: 0,
      collapse: false
    }
  }

  onDeviceChange = (newVal) => {
    this.setState({
      curDevice: newVal
    })
  }

  getSummarySource = (summaryTable) =>
    summaryTable.map((x, idx) => {
      return { value: idx, label: x.title }
    })

  onRunChange = (newVal) => {
    this.setState({
      curRun: newVal
    })
  }

  toggle = () => {
    this.setState(prevState => ({
      collapse: !prevState.collapse
    }));
  }

  runToggleValues = () => {
    let values = []
    for (let i = 0; i < this.totalRuns(); i++) {
      values.push({ value: i, label: `Run ${i + 1}` })
    }
    return values
  }

  totalRuns = () => {
    const { data } = this.props
    try {
      return data[0][0]['linkDataRate'].length
    } catch (e) {
      return 1
    }
  }

  renderResultTable(curDevice) {
    let { data } = this.props
    data = data[curDevice]
    const run = this.state.curRun

    let rows = data.map((row, idx) => (
      <TableRow key={idx}>
        <TableCell key={`type${idx}`}>{row.type}</TableCell>
        <TableCell key={`device${idx}`}><code>{row.device}</code></TableCell>
        <TableCell key={`remoteConnection${idx}`}><code>{row.remoteConnection[run]}</code></TableCell>
        <TableCell key={`linkNumber${idx}`}>{row.linkNumber}</TableCell>

        <TableCell key={`fomValues${idx}`}>{row.fomValues ? row.fomValues[run] : 'N/A'}</TableCell>
        <TableCell key={`eom${idx}`}>{row.eom}</TableCell>
        <TableCell key={`linkDataRate${idx}`}>{row.linkDataRate[run]}</TableCell>
      </TableRow>
    ));
    rows = this.state.collapse ? rows : rows.slice(0, 2)

    const tableClass = !this.state.collapse ? cn(styles.table, styles.tableNotCollapsed) : styles.table

    return (
      <Table selectable={false} className={tableClass}>
        <TableHead key={`head`}>
          <TableCell key={`type`}>Type</TableCell>
          <TableCell key={`device`}>Device</TableCell>

          <TableCell key={`remoteConnection`}>Remote Conection</TableCell>
          <TableCell key={`linkNumber`}>Link Number</TableCell>

          <TableCell key={`fomValues`}>FOM Values</TableCell>
          <TableCell key={`eom`}>EOM Values</TableCell>
          <TableCell key={`linkDataRate`}>Link Data Rate</TableCell>
        </TableHead>
        {rows}
      </Table>
    )
  }

  render() {
    const { data, error, onDownloadFile, files, testName, testId, result, subtestDetails } = this.props

    const hasErrorData = error && error.length > 0
    const {
      collapse,
      curDevice
    } = this.state

    return (
      <Section>
        <ReportHeader
          title={T.translate(`containers.project.nvqualSection.test.${testId}`)} />
        <Section>
          <Section>
            <SuccessStatus result={result} />
            {subtestDetails && <SubtestSummary subTestResults={subtestDetails} />}

            {hasErrorData &&
              <React.Fragment>
                <ReportHeader2 title={'Errors'} />
                <ErrorTable
                  errors={error}
                  errorSpecificRenderFunc={this.renderAdditionalErrorInformation} />
              </React.Fragment>}

          </Section>
          {data && data.length > 0 &&
            <Section>
              <ReportHeader2
                showDropdown
                value={curDevice}
                source={[
                  { value: 0, label: 'GLink' },
                  { value: 1, label: 'CLink' }
                ]}
                onChange={this.onDeviceChange}
                title={'Device Details'}
              />
              <ReportHeader2
                showDropdown
                value={this.state.curRun}
                source={this.runToggleValues()}
                onChange={this.onRunChange}
                title={'Test Run'}
              />
              <div className={styles.tableContainer}>
                {this.renderResultTable(curDevice)}
                <CollapsableOverlay collapse={collapse} toggleCollapseFunc={this.toggle} />
              </div>
            </Section>}
        </Section>
      </Section>
    );
  }
}

const withStyles = CSSModules(styles);
const enhance = compose(withStyles);
export default enhance(NvlinkQualTestEnterprise);